export default "__VITE_ASSET__CSNG24IQ__"